/** A search rule in plain words — shared by the rule cards and the decision log (Stage 3, Oct 22 2026). */
import type { SearchRule } from '../../types/taOutreach';

export const list = (terms: string[]) => terms.map((t) => `“${t}”`).join(', ');

/** One rule in plain words. */
export function ruleText(r: Pick<SearchRule, 'kind' | 'label' | 'terms'>): string {
  const where = r.label ? ` for “${r.label}”` : '';
  switch (r.kind) {
    case 'add_terms':
      return `Also search for ${list(r.terms)}${where}`;
    case 'remove_terms':
      return `Stop searching for ${list(r.terms)}${where}`;
    case 'exclude_terms':
      return `Leave out profiles that mention ${list(r.terms)}`;
    case 'add_titles':
      return `Also search for the titles ${list(r.terms)}`;
    case 'remove_titles':
      return `Stop searching for the titles ${list(r.terms)}`;
    case 'search_without':
      return `Stop searching for “${r.label}” — the screening still checks it`;
  }
}
